<script>
    import { onMount } from "svelte";
    import DateInput from "../../../Components/Common/DateInput.svelte";
    import { apiMethods } from "../../../Services/index.svelte";
    import { showInfo } from "../../../Utils/utilFunctions.svelte";

    export let latestQuoteData, sendQuote, patientEncounterDetails, customDueDate;

    onMount(() => {
        if(latestQuoteData.oopType == 0 && latestQuoteData.actualGap > 0) {
            //only load default quote due date for prepay with gap
            getDefaultDueDate();
        }
    })

    const getDetails = () => {
        let details = [
            "Create quote",
            "Send patient payment link ± preop instructions ± survey"
        ];
       
        details.push("Change encounter status to QUOTED");

        return details;
    }

    const getDefaultDueDate = async () => {
        var quoteDefaultDueDate = await apiMethods.getMethod.getEstimateDueDateByBillingItem(latestQuoteData.id);

        if(quoteDefaultDueDate) {
            customDueDate = new Date(quoteDefaultDueDate);
        }
    }

</script>

<div class="flex flex-col gap-y-4">
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div on:click={() => sendQuote = false } class={`option-item ${!sendQuote ? `option-active` : ''}`}>
       <div class="flex flex-row gap-x-4 items-center">
            <i class="option-icon fa-solid fa-file"></i>Create Only
       </div> 
       <div class="option-details">
            <div class="details-item">
                <div class="details-item-indicator">
                    1
                </div>
                <div class="details-item-text">
                    Create quote
                </div>
            </div>
             <div class="details-item">
                <div class="details-item-indicator">
                    2
                </div>
                <div class="details-item-text">
                    Change encounter status to QUOTED
                </div>
            </div>
       </div>
    </div>
    
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div  on:click={() => sendQuote = true } class={`option-item ${sendQuote ? `option-active` : ''}`}>
        <div class="flex flex-row gap-x-4 items-center">
            <i class="option-icon fa-solid fa-paper-plane"></i>Create & Send
        </div>
        <div class="option-details">
            {#each getDetails() as details, index}
                <div class="details-item">
                    <div class="details-item-indicator">
                        {index + 1}
                    </div>
                    <div class="details-item-text">
                        {details}
                    </div>
                </div>
            {/each}
        </div>
    </div>

    <!-- show due date on quote only if prepay with gap, max available due date is scheduled date of encounter -->
    {#if latestQuoteData.oopType == 0 && latestQuoteData.actualGap > 0}
        <div class="flex flex-col gap-y-2">
            <p class="text-sm">Quote Due Date</p>

            <DateInput
                bind:value={customDueDate}
                minDate={new Date()} 
                maxDate={patientEncounterDetails.scheduledDate ?? null}
                wrapperClass="input input-sm px-2 input-bordered w-60"
            />
        </div>
    {/if}

</div>

<style>
   .option-item {
        width: 100%;
        border-radius: 6px;
        background-color: #f5f5f5;
        padding:15px;
        display: flex;
        flex-direction: column;
        gap: 10px;
   }

   .option-item:hover {
        cursor: pointer;
        border: 1px solid rgb(146 68 225);
   }

    .option-details {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .details-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 10px;
    }

    .details-item-indicator {
        font-size: 12px;
        width: 30px;
        height: 30px;
        border-radius: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #d4d4d4;
    }

    .details-item-text {
        flex:1;
        display: flex;
        align-items: center;
        font-size: 12px;
    }

   .option-active {
        background-color: aliceblue;
        border: 1px solid rgb(146 68 225);
   }

   .option-active .option-icon {
        color: rgb(146 68 225);
   }

   .option-active .details-item-indicator {
    background-color: rgb(146 68 225);
    color: white;
   }
</style>
